import { api } from 'api/axios';
import { useQuery } from '@tanstack/react-query';

import urls from 'engine/urls';

const getCostsInvoicing = (params) => api.get(urls().GetCostInvoice, { params });

export const useGetCostsInvoicing = (id, options) =>
  useQuery({
    queryKey: ['CostsInvoicingHeaders', id],
    queryFn: () => getCostsInvoicing({ id }),
    ...options,
  });
